import auth from '@client/components/auth';

// Either the content is yours, or you are an administrator editing the
// creator's content for them. The backend never marks creator content as
// "own" for an administrator, so authorship alone is not enough.
export const canEditContent = (isOwn: boolean, isCreator: boolean): boolean =>
  isOwn || (auth.isAdministrator() && isCreator);
